// extracted by mini-css-extract-plugin
module.exports = {"page":"IUsZZxeDJkUDpLl6eQFlV","tabs":"_2VgMGLt5-kL6tCbdEmUZIe","tabContent":"_3qQApHeLWJRBlJ56PNlP0q"};